
import React from "react";
import { Scripture } from "@/hooks/prayer/types";

interface PrayerTextProps {
  prayer: string;
  scriptures: Scripture[];
}

const PrayerText: React.FC<PrayerTextProps> = ({ prayer, scriptures }) => {
  // Format prayer text to highlight scripture references
  const formatPrayer = (text: string) => {
    let formattedText = text;
    
    // Replace scripture references with highlighted spans
    scriptures.forEach((scripture) => {
      const regex = new RegExp(`(${scripture.reference})`, 'gi');
      formattedText = formattedText.replace(
        regex, 
        '<span class="font-semibold text-selah-gold">$1</span>'
      );
    });
    
    // Replace newlines with proper HTML breaks
    formattedText = formattedText.replace(/\n/g, '<br />');
    
    return formattedText;
  };

  return (
    <div 
      className="prose prose-lg max-w-none mb-8 leading-relaxed text-selah-navy"
      dangerouslySetInnerHTML={{ __html: formatPrayer(prayer) }}
    />
  );
};

export default PrayerText;
